// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-card__container {
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
}

.project-card__footer {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  background-color: var(--secondary-color);
}

.project-card__name {
  color: var(--web-primary-color);
  font-weight: 800;
  line-height: 140%;
}
.project-card__name:first-letter {
  text-transform: uppercase;
  color: var(--accent-color);
}

.project-card__image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 50%;
}

@media only screen and (min-device-width: 320px) {
  .project-card__image {
    height: 200px;
  }
  .project-card__name {
    font-size: 24px;
    letter-spacing: 1.2px;
    margin-bottom: 16px;
  }
  .project-card__footer {
    padding: 32px 16px 16px 16px;
  }
}
@media only screen and (min-device-width: 768px) {
  .project-card__image {
    height: 288px;
  }
  .project-card__name {
    font-size: 36px;
    letter-spacing: 1.8px;
    margin-bottom: 16px;
  }
  .project-card__footer {
    padding: 32px;
  }
}
@media only screen and (min-device-width: 992px) {
  .project-card__image {
    height: 326px;
  }
  .project-card__name {
    font-size: 44px;
    letter-spacing: 2.2px;
    margin-bottom: 16px;
  }
  .project-card__footer {
    padding: 32px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .project-card__image {
    height: 358px;
  }
  .project-card__name {
    font-size: 52px;
    letter-spacing: 2.6px;
    margin-bottom: 16px;
  }
  .project-card__footer {
    padding: 24px 44px 44px 44px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/LandingPage/components/ProjectCard/projectCard.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;AACF;;AACA;EACE,+BAAA;EACA,gBAAA;EACA,iBAAA;AAEF;AAAE;EACE,yBAAA;EACA,0BAAA;AAEJ;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AACF;;AACA;EAIE;IACE,aAAA;EADF;EAGA;IACE,eAAA;IACA,qBAAA;IACA,mBAAA;EADF;EAMA;IACE,4BAAA;EAJF;AACF;AAMA;EAIE;IACE,aAAA;EAPF;EASA;IACE,eAAA;IACA,qBAAA;IACA,mBAAA;EAPF;EAYA;IACE,aAAA;EAVF;AACF;AAYA;EAGE;IACE,aAAA;EAZF;EAcA;IACE,eAAA;IACA,qBAAA;IACA,mBAAA;EAZF;EAiBA;IACE,aAAA;EAfF;AACF;AAmBA;EAGE;IACE,aAAA;EAnBF;EAqBA;IACE,eAAA;IACA,qBAAA;IACA,mBAAA;EAnBF;EAwBA;IACE,4BAAA;EAtBF;AACF","sourcesContent":[".project-card__container {\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n  overflow: hidden;\n  //border: 2px solid var(--border-color);\n}\n.project-card__footer{\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  background-color: var(--secondary-color);\n}\n.project-card__name {\n  color: var(--web-primary-color);\n  font-weight: 800;\n  line-height: 140%;\n\n  &:first-letter {\n    text-transform: uppercase;\n    color: var(--accent-color);\n  }\n}\n\n.project-card__image {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-height: 50%;\n}\n@media only screen and (min-device-width: 320px) {\n  .project-card__container {\n    //padding: 20px 16px;\n  }\n  .project-card__image {\n    height: 200px;\n  }\n  .project-card__name {\n    font-size: 24px;\n    letter-spacing: 1.2px;\n    margin-bottom: 16px;\n  }\n  //.project-card__info {\n  //  margin-bottom: 24px;\n  //}\n  .project-card__footer{\n    padding: 32px 16px 16px 16px;\n  }\n}\n@media only screen and (min-device-width: 768px) {\n  .project-card__container {\n    //padding: 36px;\n  }\n  .project-card__image {\n    height: 288px;\n  }\n  .project-card__name {\n    font-size: 36px;\n    letter-spacing: 1.8px;\n    margin-bottom: 16px;\n  }\n  //.project-card__info {\n  //  margin-bottom: 24px;\n  //}\n  .project-card__footer{\n    padding: 32px;\n  }\n}\n@media only screen and (min-device-width: 992px) {\n  .project-card__container {\n  }\n  .project-card__image {\n    height: 326px;\n  }\n  .project-card__name {\n    font-size: 44px;\n    letter-spacing: 2.2px;\n    margin-bottom: 16px;\n  }\n  //.project-card__info {\n  //  margin-bottom: 48px;\n  //}\n  .project-card__footer{\n    padding: 32px;\n    //height: 291px;\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .project-card__container {\n  }\n  .project-card__image {\n    height: 358px;\n  }\n  .project-card__name {\n    font-size: 52px;\n    letter-spacing: 2.6px;\n    margin-bottom: 16px;\n  }\n  //.project-card__info {\n  //  margin-bottom: 48px;\n  //}\n  .project-card__footer{\n    padding: 24px 44px 44px 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
